(function () {
  const STORAGE_KEY = 'rwady.search.history';
  const MAX_ITEMS = 8;

  const isSearchForm = (form) => {
    if (!form) return false;
    if (form.closest('predictive-search')) return false;
    return Boolean(
      form.matches('.js_frm_search, .search-header, .search, .main-search form, form[role="search"]') ||
        form.querySelector('input[name="q"]')
    );
  };

  const getHistory = () => {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      const items = value ? JSON.parse(value) : [];
      return Array.isArray(items) ? items.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  const saveHistory = (query) => {
    const normalized = (query || '').trim();
    if (!normalized) return;

    const nextHistory = [normalized, ...getHistory().filter((item) => item.toLowerCase() !== normalized.toLowerCase())].slice(0, MAX_ITEMS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(nextHistory));
    } catch (error) {
      // Ignore storage limits/private mode.
    }
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const ensureHistoryStyles = () => {
    if (document.getElementById('rw-search-history-styles')) return;
    const style = document.createElement('style');
    style.id = 'rw-search-history-styles';
    style.textContent = `
      [data-search-history-item="true"] { cursor: pointer !important; transition: background-color 160ms ease, color 160ms ease, padding-inline 160ms ease; }
      [data-search-history-item="true"]:hover,
      [data-search-history-item="true"]:focus-visible { background: #edf3ff !important; color: #174bb6 !important; outline: none; }
      [data-search-history-item="true"]:hover span:last-child,
      [data-search-history-item="true"]:focus-visible span:last-child { color: #174bb6 !important; transform: translateX(3px); }
      [data-search-history-item="true"]:active { background: #dfe9ff !important; }
      html[dir="rtl"] [data-search-history-item="true"]:hover span:last-child,
      html[dir="rtl"] [data-search-history-item="true"]:focus-visible span:last-child { transform: translateX(-3px); }
    `;
    document.head.appendChild(style);
  };

  const createPanel = (form) => {
    ensureHistoryStyles();
    const panelHost = form.parentElement;
    let panel = panelHost ? panelHost.querySelector('[data-search-history-panel]') : null;
    if (panel) return panel;

    panel = document.createElement('div');
    panel.setAttribute('data-search-history-panel', 'true');
    panel.style.cssText = [
      'position:absolute',
      'inset-inline-start:0',
      'inset-inline-end:0',
      'top:calc(100% + 8px)',
      'z-index:60',
      'display:none',
      'background:#fff',
      'border:1px solid rgba(15,76,180,0.16)',
      'border-radius:12px',
      'box-shadow:0 18px 36px rgba(15,23,42,0.14)',
      'overflow:hidden'
    ].join(';');

    if (!panelHost) return panel;
    panelHost.style.position = 'relative';
    panelHost.appendChild(panel);
    return panel;
  };

  const renderHistory = (form, input) => {
    const panel = createPanel(form);
    const history = getHistory();
    const query = (input.value || '').trim().toLowerCase();
    const filtered = query ? history.filter((item) => item.toLowerCase().includes(query)) : history;

    if (!filtered.length) {
      panel.style.display = 'none';
      panel.innerHTML = '';
      return;
    }

    const heading = form.closest('.rowady-custom-header-wrapper')?.getAttribute('dir') === 'rtl'
      ? 'عمليات البحث السابقة'
      : 'Recent searches';

    panel.innerHTML = `
      <div style="padding:12px 14px;border-bottom:1px solid rgba(15,76,180,0.08);font-size:12px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;">
        ${escapeHtml(heading)}
      </div>
      <div>
        ${filtered
          .map(
            (item) => `
              <button type="button" data-search-history-item="true" data-value="${escapeHtml(item)}" aria-label="${escapeHtml(item)}" style="display:flex;width:100%;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border:0;background:#fff;color:#111827;font-size:14px;cursor:pointer;text-align:start;">
                <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${escapeHtml(item)}</span>
                <span style="color:#94a3b8;flex:0 0 auto;">↲</span>
              </button>
            `
          )
          .join('')}
      </div>
    `;

    panel.style.display = 'block';
  };

  const hidePanel = (form) => {
    const panel = form.parentElement ? form.parentElement.querySelector('[data-search-history-panel]') : null;
    if (!panel) return;
    panel.style.display = 'none';
  };

  const selectHistoryItem = (form, input, trigger) => {
    const query = (trigger.dataset.value || '').trim();
    if (!query) return;

    input.value = query;
    saveHistory(query);
    hidePanel(form);

    const searchUrl = new URL(form.getAttribute('action') || '/search', window.location.origin);
    const formData = new FormData(form);
    formData.set('q', query);
    formData.forEach((value, key) => searchUrl.searchParams.set(key, value));
    window.location.assign(searchUrl.toString());
  };

  const setupForm = (form) => {
    if (!isSearchForm(form) || form.dataset.searchHistoryInit === 'true') return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    form.dataset.searchHistoryInit = 'true';

    const openHistory = () => renderHistory(form, input);

    input.addEventListener('focus', openHistory);
    input.addEventListener('input', openHistory);
    input.addEventListener('blur', () => {
      setTimeout(() => hidePanel(form), 120);
    });

    form.addEventListener('submit', () => {
      saveHistory(input.value);
      hidePanel(form);
    });

    const panel = createPanel(form);
    panel.addEventListener('pointerdown', (event) => {
      const trigger = event.target.closest('[data-search-history-item="true"]');
      if (!trigger) return;
      event.preventDefault();
      selectHistoryItem(form, input, trigger);
    });

    panel.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-search-history-item="true"]');
      if (!trigger) return;
      event.preventDefault();
      selectHistoryItem(form, input, trigger);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      const visiblePanel = createPanel(form);
      if (visiblePanel.style.display !== 'block') renderHistory(form, input);
      const firstItem = visiblePanel.querySelector('[data-search-history-item="true"]');
      if (!firstItem) return;
      event.preventDefault();
      firstItem.focus();
    });

    panel.addEventListener('keydown', (event) => {
      const currentItem = event.target.closest('[data-search-history-item="true"]');
      if (!currentItem) return;
      const items = Array.from(panel.querySelectorAll('[data-search-history-item="true"]'));
      const currentIndex = items.indexOf(currentItem);

      if (event.key === 'ArrowDown' && items[currentIndex + 1]) {
        event.preventDefault();
        items[currentIndex + 1].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (items[currentIndex - 1]) {
          items[currentIndex - 1].focus();
        } else {
          input.focus();
        }
      } else if (event.key === 'Escape') {
        hidePanel(form);
        input.focus();
      }
    });
  };

  const init = () => {
    document.querySelectorAll('form').forEach(setupForm);
    document.addEventListener('click', (event) => {
      document.querySelectorAll('form[data-search-history-init="true"]').forEach((form) => {
        const panel = form.parentElement ? form.parentElement.querySelector('[data-search-history-panel]') : null;
        if (!form.contains(event.target) && !(panel && panel.contains(event.target))) hidePanel(form);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
